exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cart-icon-container[data-v-d2aeb7d8] {\n  position: relative;\n  width: 23px;\n  height: 33px;\n  top: 1px;\n}\n.cart-icon-container .count[data-v-d2aeb7d8] {\n  position: absolute;\n  top: calc(50% - 1px);\n}\n.cart-icon-container .cart-icon[data-v-d2aeb7d8] {\n  width: 23px;\n  height: 35px;\n}\n.cart-icon-container .cart-icon path.background[data-v-d2aeb7d8] {\n  fill: #000;\n}\n.cart-icon-container .cart-icon path.outline[data-v-d2aeb7d8] {\n  fill: #fff;\n}", ""]);

// exports
